import type { TypedDocumentNode } from "urql";

import { gql } from "urql";

import type {
  getBatchClaimAssigneeAuthorAndProviderInfoQuery,
  getBatchClaimAssigneeAuthorAndProviderInfoQueryVariables,
} from "../gql/graphql";

export const getBatchClaimAssigneeAuthorAndProviderInfoQueryDoc = gql`
  query getBatchClaimAssigneeAuthorAndProviderInfo(
    $batchClaimId: UUID!
    $includeAdminFields: Boolean!
  ) {
    batchClaim(id: $batchClaimId) {
      __typename
      id
      nodeId
      claimAuditType
      computationStrategy
      paymentRate
      actionPermissions {
        bypassOrganizationAdmin
        claimId
        createBlocker
        createFinding
        currentStageId
        deleteBlocker
        editBlocker
        editFinding
        editStage
      }
      appealed
      disputed
      provider {
        __typename
        id
        name
        npi
        practiceType
        spec
      }
      icn
      claimType
      clientGroupName
      dateOfServiceStart
      dateOfServiceEnd
      dateAdmit
      dateDischarge
      dischargeStatus
      amountReimbursed
      amountCharged
      patientDob
      batchClaimLines {
        nodes {
          id
          revCode
          paymentRate
        }
      }
      stageTracker {
        __typename
        canChangeStage
        changeStageDisabledReason
        currentStageEnteredAt
        visitedStageIds
        currentStage {
          __typename
          description
          id
          labelOrder
          name
          slug
          sortOrder
          status
          type
          stageDetail
        }
        nextRecommendedStage {
          __typename
          description
          id
          labelOrder
          name
          slug
          sortOrder
          status
          type
        }
        suggestedStages {
          __typename
          priority
          stage {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            status
            type
          }
        }
        phases {
          __typename
          description
          id
          labelOrder
          name
          slug
          sortOrder
          status
          stages {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            status
            type
          }
        }
        blockers {
          __typename
          canChangeSegment
          createdAt
          description
          id
          status
          title
          createdDuringStage {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            status
            type
          }
          segments {
            __typename
            id
            label
            slug
            status
          }
          segmentHistory {
            __typename
            enteredAt
            exitedAt
            id
            segment {
              __typename
              id
              label
              slug
              status
            }
          }
        }
        stageHistory {
          __typename
          appliedByUserId
          enteredAt
          exitedAt
          id
          stage {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            status
            type
          }
        }
      }
      batchClaimState: batchClaimStateById {
        __typename
        id
        onHoldClaimState
        documentationClaimState
        reported
        disputedFindingClaimState
        workflowClaimState
        negotiationClaimState
        providerSignOffClaimState
        clientSignOffClaimState
        invoiceClaimState
        isProviderActive
        isRealized
        determinedDiscrepantAmount
        potentialDiscrepantAmount
        potentialClientSavings
        determinedClientSavings
        potentialAdjustedAllowedAmount
        determinedAdjustedAllowedAmount
        dueDate
        auditStartDate
        techDenied
        appealed
      }
      auditDocumentation {
        __typename
        fileName
        id
        process
        signedUrl
        size
        subFile
      }
      activeDueDate: batchClaimStateById @include(if: $includeAdminFields) {
        __typename
        id
        dueDate
      }
      activeAssignees @include(if: $includeAdminFields) {
        __typename
        nodes {
          __typename
          id
          firstName
          lastName
        }
      }
      claimAuditor @include(if: $includeAdminFields) {
        __typename
        id
        firstName
        lastName
      }
    }
  }
` as TypedDocumentNode<
  getBatchClaimAssigneeAuthorAndProviderInfoQuery,
  getBatchClaimAssigneeAuthorAndProviderInfoQueryVariables
>;
